import React, { useMemo } from 'react';

import Icon, { faCheck, faMinus, faXmark } from '~components/icon';

interface ComponentProps {
  id: string;
  row: any;
}

const ClaimValidIcon: React.FC<ComponentProps> = ({ id, row }) => {
  const indicator = useMemo(() => {
    if (row.error) {
      return <Icon icon={faXmark} color="red" />;
    }
    if (row.is_ignored) {
      return <Icon icon={faMinus} />;
    }
    return <Icon icon={faCheck} color="green" />;
  }, [row.error, row.is_ignored]);

  return (
    <>
      <div className="d-flex justify-content-center" id={`claim-valid-icon-${id}`}>
        {indicator}
      </div>
    </>
  );
};

export default ClaimValidIcon;
